import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import Sidebar from '../components/Sidebar';
import './Profile.css';

const Profile: React.FC = () => {
  const { user } = useAuth();

  return (
    <div className="layout">
      <Sidebar />
      <div className="main-content">
        <div className="top-bar">
          <div className="user-info">
            <span className="user-icon">👤</span>
            <span className="user-email">{user?.email || 'admin@roameez.com'}</span>
          </div>
        </div>

        <div className="page-container">
          <div className="page-header">
            <div>
              <h1 className="page-title">Profile</h1>
              <div className="breadcrumb">
                <span>Dashboard</span>
                <span className="breadcrumb-separator">›</span>
                <span>Profile</span>
              </div>
            </div>
          </div>

          <div className="profile-container">
            <div className="profile-card">
              <h2>User Information</h2>
              <div className="profile-info">
                <div className="profile-item">
                  <label>Name:</label>
                  <span>{user?.name || '-'}</span>
                </div>
                <div className="profile-item">
                  <label>Email:</label>
                  <span>{user?.email || '-'}</span>
                </div>
                <div className="profile-item">
                  <label>Phone:</label>
                  <span>{user?.phone || '-'}</span>
                </div>
                <div className="profile-item">
                  <label>Username:</label>
                  <span>{user?.username || '-'}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
